<script setup lang="ts">
import { type LandingContentsProvidersInner } from '@clients/ContentApi';

interface IProps {
    logos?: LandingContentsProvidersInner[];
    logoHeight?: number;
}
defineProps<IProps>();
const expand = ref<number>();
</script>
<template>
    <div class="logos-container">
        <div class="logos">
            <div
                v-for="(item, index) in logos"
                :key="index"
                class="logo"
                :style="{ height: logoHeight ? `${logoHeight}px` : 'auto' }"
            >
                <a
                    :href="item.link"
                    :rel="item.rel"
                    target="_blank"
                    class="link"
                >
                    <mr-lazy-img
                        class="image"
                        :src="item.image?.[0]?.url || ''"
                        image-fit="contain"
                        :alt="item.alt"
                    />
                    <mr-typography
                        v-if="item.title"
                        size="small"
                        weight="600"
                        color="var(--cool-gray-800)"
                        align="center"
                    >
                        {{ item.title }}
                    </mr-typography>

                    <mr-typography
                        v-if="item.description"
                        :class="{ expand: expand === index }"
                        size="x-small"
                        color="var(--cool-gray-700)"
                        align="center"
                        weight="500"
                        class="caption"
                    >
                        {{ item.description }}
                    </mr-typography>
                </a>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.logos-container {
    margin-top: 24px;
    padding-bottom: 5px;
    overflow-y: scroll;
    @include scroll-fantasy;
}

.logos {
    overflow-x: scroll;
    direction: ltr;
    display: flex;
    align-items: flex-start;
    flex-direction: row-reverse;
    width: 100%;
    padding-bottom: 8px;
    overflow-y: hidden;
    -ms-overflow-style: none;
    @include scroll-fantasy;
    @include mobile-only {
        flex-shrink: 0;
    }
}

.link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    max-width: 100%;
    padding-inline: 8px;
    gap: 6px;
    color: inherit;
    text-decoration: none !important;
}

.logo {
    background: white;
    border: 1px solid usePalette($p-cool-gray);
    box-sizing: border-box;
    border-radius: 14px;
    width: 288px !important;
    max-height: 250px;
    position: relative;
    padding-block: 24px;
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 8px;
    flex-shrink: 0;
}

.image {
    height: 61px;
    width: 100%;
    max-width: 100%;
    aspect-ratio: 4/2;
}

.big-pic {
    padding: 17px;
}

.caption {
    overflow: hidden;
    @include mobile-only {
        text-overflow: ellipsis;
    }
}
</style>
